import {useEffect} from 'react';
import {useSearchParams} from 'react-router-dom';
import {Button} from '@tinct/web-components';

export const IntegrationOauthCallbackPage = () => {
  const [searchParams] = useSearchParams();
  const success = searchParams.get('success') === 'true';
  const errorMessage = searchParams.get('error_message') ?? searchParams.get('error');

  useEffect(() => {
    const message = { type: 'oauth-callback', success, error: errorMessage };

    // BroadcastChannel works reliably across same-origin windows,
    // even when window.opener is null after cross-origin redirects.
    const channel = new BroadcastChannel('oauth-callback');
    channel.postMessage(message);
    channel.close();

    // Fallback for older browsers where BroadcastChannel may not be available
    if (window.opener) {
      window.opener.postMessage(message, window.location.origin);
    }

    if (!success) return;

    const timeout = setTimeout(() => {
      window.close();
    }, 500);
    return () => clearTimeout(timeout);
  }, [success, errorMessage]);

  if (!success) {
    return (
      <div className="flex h-screen items-center justify-center p-6">
        <div className="max-w-md text-center">
          <div className="text-lg font-medium text-destructive">
            Authentication failed
          </div>
          <div className="text-sm text-muted-foreground mt-2 whitespace-pre-wrap">
            {errorMessage ?? 'An unknown error occurred.'}
          </div>
          <Button className="mt-6" onClick={() => window.close()}>
            Close window
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex h-screen items-center justify-center">
      <div className="text-center">
        <div className="text-lg font-medium">Completing authentication...</div>
        <div className="text-sm text-muted-foreground mt-2">
          This window will close automatically.
        </div>
      </div>
    </div>
  );
};
